"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeNormalOneLine = void 0;
const CTGGameModeNormal_1 = require("./CTGGameModeNormal");
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameMode_1 = require("./CTGGameMode");
const CTGIntroAnimations_1 = require("../Display/CTGIntroAnimations");
const standard_1line_animations = [
    new CTGIntroAnimations_1.CTGAnimationFadeIn(),
    new CTGIntroAnimations_1.CTGAnimationFadeInFlip(),
    new CTGIntroAnimations_1.CTGAnimationScaleIn(),
    new CTGIntroAnimations_1.CTGAnimationScaleInFlip(),
    new CTGIntroAnimations_1.CTGAnimationDropIn(),
    new CTGIntroAnimations_1.CTGAnimationDropInFlip(),
];
class CTGGameModeNormalOneLine extends CTGGameModeNormal_1.CTGGameModeNormal {
    constructor(generator, base_score) {
        super(false, generator, 5, new CTGGameModeNormal_1.CTGNoSpeed());
        this.win_on_time_out = false;
        this.base_score = base_score;
    }
    supported_animations() {
        return standard_1line_animations;
    }
    start(scene, rand, difficulty) {
        super.start(scene, rand, difficulty);
        this.emitEvent(CTGGameMode_1.CTGGameMode.EVENT_SHOW_SHIELD);
    }
    reset() {
        super.reset();
        this._scrolling = false;
    }
    target_score() {
        return Math.floor(this.base_score * (1 + this.difficulty));
    }
    card_destroyed(card) {
        super.card_destroyed(card);
        if (card.tap_requirement != CTGCard_1.CTGTapRequirement.Must)
            return;
        let new_score = this.score + 1;
        this.set_score(new_score, new_score / this.target_score());
        if (new_score >= this.target_score()) {
            this.win();
        }
        else {
            this.check_scroll();
        }
    }
    game_ended() {
        super.game_ended();
        this.emitEvent(CTGGameMode_1.CTGGameMode.EVENT_HIDE_SHIELD);
    }
    check_scroll() {
        if (this.game_over)
            return;
        let still_requires_tap = false;
        for (let card of this.rows[0]) {
            if (!card.destroyed && card.tap_requirement == CTGCard_1.CTGTapRequirement.Must) {
                still_requires_tap = true;
                break;
            }
        }
        if (!still_requires_tap) {
            this.add_row();
            this.scroll();
        }
    }
    scroll() {
        if (this._scrolling || this.game_over)
            return;
        this._scrolling = true;
        const tween = this.scene.tweens.addCounter({
            from: 0,
            to: this.spacing(),
            duration: 100,
            ease: 'Quad.easeInOut',
            onUpdate: () => {
                for (let i = 0; i < this.rows.length; i++) {
                    let row = this.rows[i];
                    let y = this.fixed_y_position(i) + tween.getValue();
                    row.forEach(card => {
                        card.move(card.x, y);
                    });
                }
            },
            onComplete: () => {
                this._scrolling = false;
                let row = this.rows.shift();
                this.row_off_screen(row);
                this.check_scroll();
            }
        });
    }
}
exports.CTGGameModeNormalOneLine = CTGGameModeNormalOneLine;
